import React from 'react';
import { BattleTileState, BattleUnitState, StatusEffect } from '../types/battle';
import { getHealthColor } from '../utils/battleUtils';
import { getTileTooltip, getEffectIcon } from './BattleGridTiles';

interface BattleTileInspectorProps {
  x: number;
  y: number;
  tile: BattleTileState | undefined;
  unit: BattleUnitState | undefined;
  onClose: () => void;
}

// Touch replacement for the `title` tooltips on BattleGridTiles (GH-63) - opened via
// long-press since touch has no hover. Reuses the same tooltip string/icon builders as
// the desktop tooltips so the two never drift apart.
const BattleTileInspector: React.FC<BattleTileInspectorProps> = ({ x, y, tile, unit, onClose }) => {
  const hpPct = unit && unit.stats.maxHP > 0 ? Math.max(0, unit.stats.currentHP / unit.stats.maxHP) : 0;

  return (
    <div className="tile-inspector-backdrop" onClick={onClose}>
      <div className="tile-inspector" onClick={(e) => e.stopPropagation()}>
        <button className="tile-inspector-close" onClick={onClose} aria-label="Close">×</button>

        <div className="tile-inspector-section tile-inspector-terrain">
          {getTileTooltip(tile, x, y)}
        </div>

        {unit && (
          <div className="tile-inspector-section tile-inspector-unit">
            <div className="tile-inspector-unit-name">{unit.name}</div>
            <div className="tile-inspector-unit-stats">
              <span style={{ color: getHealthColor(hpPct) }}>HP {unit.stats.currentHP}/{unit.stats.maxHP}</span>
              <span>AP {unit.stats.currentAP}/{unit.stats.maxAP}</span>
            </div>
            {unit.statusEffects && unit.statusEffects.length > 0 ? (
              <div className="tile-inspector-effects">
                {unit.statusEffects.map((effect: StatusEffect) => (
                  <div key={effect.id} className="tile-inspector-effect">
                    <span className="tile-inspector-effect-icon">{getEffectIcon(effect.effectType)}</span>
                    <span>{effect.effectName} ({effect.turnsRemaining} {effect.turnsRemaining === 1 ? 'turn' : 'turns'} left)</span>
                  </div>
                ))}
              </div>
            ) : (
              <div className="tile-inspector-no-effects">No active status effects</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default BattleTileInspector;
